import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { ActivityProgress } from 'components/misc'
import { SectionCard, SectionCardMultiple } from 'components/sections/dashboard'
import { ACTIVITY_STATES } from 'constants/enums'

const click = {
  openDetail: [
    ACTIVITY_STATES.award_leader_singoff.id,
    ACTIVITY_STATES.in_progress.id,
    ACTIVITY_STATES.assessment.id,
    ACTIVITY_STATES.complete.id,
    ACTIVITY_STATES.ceremony.id,
    ACTIVITY_STATES.office_signoff.id
  ],
  newActivity: [ACTIVITY_STATES.setup.id],
  waitingNotification: [ACTIVITY_STATES.waiting_for_approval.id]
}

export default class ActivityItemWrap extends Component {
  static propTypes = {
    activity: PropTypes.any,
    canSetupSections: PropTypes.bool,
    notification: PropTypes.func.isRequired,
    onOpenDetail: PropTypes.func.isRequired,
    onOpenNewActivity: PropTypes.func.isRequired,
    onShowReviseMessage: PropTypes.func.isRequired,
    multiple: PropTypes.bool,
    isBlocked: PropTypes.bool,
    notifyBlockedAward: PropTypes.func,
    isBadgesEnabled: PropTypes.bool,
    awardBadges: PropTypes.object,
    awardLevel: PropTypes.object
  }

  getTitle = activity => {
    const activityCategory = get(activity, 'activityCategory')
    const activityState = get(activity, 'activityState.value')
    const isReturned = get(activity, 'returnedToParticipant', false) === true

    return ACTIVITY_STATES.setup.id === activityState && !isReturned ? (
      <FormattedMessage
        id="label.choose_project"
        defaultMessage="Choose project"
      />
    ) : (
      get(activityCategory, 'translatedName')
    )
  }

  handleClick = activity => {
    const {
      canSetupSections,
      isBlocked,
      notifyBlockedAward
    } = this.props

    const activityState = get(activity, 'activityState.value')

    if (isBlocked) {
      notifyBlockedAward()
    } else if (!canSetupSections) {
      this.props.notification(
        'Activity cannot be created until your registration is approved',
        {
          intlKey: 'notifications.activity_cannot_be_created',
          status: 'info'
        }
      )
    } else if (click.openDetail.includes(activityState)) {
      this.props.onOpenDetail(activity.id)
    } else if (click.newActivity.includes(activityState)) {
      this.props.onOpenNewActivity(activity)
    } else if (click.waitingNotification.includes(activityState)) {
      this.props.notification('Waiting for approval', {
        intlKey: 'notifications.waiting_for_approval',
        status: 'info'
      })
    }
  }

  handleWarningClick = (e, singleActivity) => {
    e.stopPropagation()
    const { activity } = this.props

    this.props.onShowReviseMessage(singleActivity || activity)
  }

  determineIcon = activity => {
    const isAssessmentPositive = get(activity, 'isAssessmentPositive')
    const returnedToParticipant = get(activity, 'returnedToParticipant')
    const activityState = get(activity, 'activityState.value')

    return {
      add:
        [ACTIVITY_STATES.setup.id].includes(activityState) &&
        !returnedToParticipant,
      warning:
        [
          ACTIVITY_STATES.setup.id,
          // ACTIVITY_STATES.assessment.id,
          ACTIVITY_STATES.in_progress.id
        ].includes(activityState) && returnedToParticipant,
      pending:
        [
          ACTIVITY_STATES.waiting_for_approval.id,
          ACTIVITY_STATES.award_leader_singoff.id
        ].includes(activityState) ||
        ([ACTIVITY_STATES.assessment.id].includes(activityState) &&
          !isAssessmentPositive),
      checked:
        [
          ACTIVITY_STATES.complete.id,
          ACTIVITY_STATES.ceremony.id,
          ACTIVITY_STATES.office_signoff.id
        ].includes(activityState) && !returnedToParticipant,
      percent: false
    }
  }

  handleReturnsByAsssessor = activity =>
    get(activity, 'returnedToParticipant') &&
    !get(activity, 'isAssessmentPositive') &&
    get(activity, 'activityAssessmentActionId')

  renderMultiple = () => {
    const { activity, isBadgesEnabled, awardBadges, awardLevel } = this.props

    const activitySection = get(activity[0], 'activitySection.value')
    const completedPercentage = get(activity[0], 'completedPercentage')
    const activityStates = activity.map(item =>
      get(item, 'activityState.value')
    )

    return (
      <SectionCardMultiple
        activities={activity}
        activityProgress={
          <ActivityProgress
            activitySection={activitySection}
            completedPercentage={completedPercentage}
          />
        }
        activityState={activityStates}
        activitySection={activitySection}
        completedPercentage={completedPercentage}
        onClick={this.handleClick}
        onGetIcon={this.determineIcon}
        onGetTitle={this.getTitle}
        onWarningClick={this.handleWarningClick}
        showPercentage
        showProgress
        isBadgesEnabled={isBadgesEnabled}
        awardBadges={awardBadges}
        awardLevel={awardLevel}
      />
    )
  }

  render() {
    const { activity, multiple, isBadgesEnabled, awardBadges, awardLevel } = this.props

    if (multiple) {
      return this.renderMultiple()
    }

    const activityState = get(activity, 'activityState.value')
    const activitySection = get(activity, 'activitySection.value')
    const completedPercentage = get(activity, 'completedPercentage')

    const showProgress = [
      ACTIVITY_STATES.waiting_for_approval.id,
      ACTIVITY_STATES.award_leader_singoff.id,
      ACTIVITY_STATES.in_progress.id,
      ACTIVITY_STATES.assessment.id,
      ACTIVITY_STATES.complete.id,
      ACTIVITY_STATES.ceremony.id,
      ACTIVITY_STATES.office_signoff.id
    ].includes(activityState)

    return (
      <SectionCard
        onClick={() => this.handleClick(activity)}
        onWarningClick={e => this.handleWarningClick(e, activity)}
        activitySection={activitySection}
        title={this.getTitle(activity)}
        caption={get(activity, 'activitySection.translationText')}
        completedPercentage={completedPercentage}
        activityState={activityState}
        activityProgress={
          <ActivityProgress
            activitySection={activitySection}
            completedPercentage={completedPercentage}
          />
        }
        showProgress={showProgress}
        showPercentage
        sectionIcon={this.determineIcon(activity)}
        returnedByAssessor={this.handleReturnsByAsssessor(activity)}
        isBadgesEnabled={isBadgesEnabled}
        awardBadges={awardBadges}
        awardLevel={awardLevel}
      />
    )
  }
}
